import React, {useEffect, useState, useRef} from 'react';
import "./onboard-select-style.scss";
import Select from 'react-select';
import Icon from './images/check-box-option-icon.svg';

const OnboardSelect = (props) => {

    const selectBtn = useRef()
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const {value, error, onChange, options, placeholder, disabled, phoneType} = props;

    const onMenuOpen = () => setIsMenuOpen(true);
    const onMenuClose = () => setIsMenuOpen(false);

    const [mValue, setMValue] = useState(value);
    const [mError, setMError] = useState(error);

    useEffect(() => {
        setMError(error);
    }, [error]);

    useEffect(() => {
        setMValue(value);
    }, [value]);

    const handleChange = (event) => {
        if (error !== undefined) {
            setMError(null);
        }
        setMValue(event);
        onChange(event);
    }

    const DropdownIndicator = () => {
        if (disabled) return <></>
        return (
            <div className={"onboard-select-dropdown-icon-root"}>
                <div className={"onboard-select-dropdown-icon"}></div>
            </div>
        );
    };

    const customStyles = {
        menuPortal: (base) => ({
            ...base,
            zIndex: 1004
        }),
        option: (defaultStyles, state) => ({
            ...defaultStyles,
            color: "#000",
            backgroundColor: state.isSelected ? "#F8F8F8" : "#FFFFFF",
            fontWeight: 500,
            fontSize: '13px',
            paddingLeft: '24px',
            backgroundImage: state.isSelected ? `url(${Icon})` : '',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 16px top 45%',
            backgroundSize: '12px',
            paddingTop: '14px',
            paddingBottom: '14px'
        }),
        control: (defaultStyles, {isDisabled}) => ({
            ...defaultStyles,
            backgroundColor: isDisabled ? '#F2F3F5' : "#FFFFFF",
            color: isDisabled ? "#7A7A7B" : "#000000",
            padding: "0",
            height: "62px",
            boxShadow: "none",
            border: mError ? "1px solid #E30613 !important" : "1px solid var(--gray-100, #E3E3E4)",
            borderRadius: "4px",
            fontWeight: 500,
            fontSize: '15px'
        }),
        indicatorSeparator: (defaultStyles) => ({
            ...defaultStyles,
            backgroundColor: "#FFFFFF",
        }),
        indicatorsContainer: (defaultStyles) => ({
            ...defaultStyles,
            opacity: 0,
        }),
        singleValue: (defaultStyles, {isDisabled}) => ({
            ...defaultStyles,
            color: isDisabled ? "#7A7A7B" : "#000000",
            padding: "27px 10px 10px 6px",
        }),
    };

    const customPhoneTypeStyles = {
        menu: (provided) => ({
            ...provided,
            width: 'auto',
            minWidth: '100%', // En az select kadar
            maxWidth: '200px', // Maksimum genişlik
        }),
        menuList: (provided) => ({
            ...provided,
            whiteSpace: 'nowrap', // Metni kesmeden göster
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 1004
        }),
        option: (defaultStyles, state) => ({
            ...defaultStyles,
            color: "#000",
            backgroundColor: state.isSelected ? "#F8F8F8" : "#FFFFFF",
            fontWeight: 500,
            fontSize: '12px',
            paddingLeft: '7px',
            backgroundImage: state.isSelected ? `url(${Icon})` : '',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 16px top 45%',
            backgroundSize: '12px',
            paddingTop: '7px',
            paddingBottom: '7px'
        }),
        control: (defaultStyles, {isDisabled}) => ({
            ...defaultStyles,
            backgroundColor: isDisabled ? '#F2F3F5' : "#FFFFFF",
            color: isDisabled ? "#7A7A7B" : "#000000",
            padding: "0",
            height: "62px",
            boxShadow: "none",
            border: mError ? "1px solid #E30613 !important" : "1px solid var(--gray-100, #E3E3E4)",
            borderRadius: "4px",
            fontWeight: 500,
            fontSize: '15px'
        }),
        indicatorSeparator: (defaultStyles) => ({
            ...defaultStyles,
            backgroundColor: "#FFFFFF",
        }),
        indicatorsContainer: (defaultStyles) => ({
            ...defaultStyles,
            opacity: 0,
        }),
        singleValue: (defaultStyles, {isDisabled}) => ({
            ...defaultStyles,
            color: isDisabled ? "#7A7A7B" : "#000000",
            padding: "27px 10px 10px 6px",
        }),
    };

    return (
        <div className="onboard-select-root">
            <Select
                ref={selectBtn}
                isSearchable={false}
                placeholder={""}
                styles={phoneType ? customPhoneTypeStyles : customStyles}
                menuPortalTarget={document.body}
                onMenuOpen={onMenuOpen}
                onMenuClose={onMenuClose}
                options={options}
                onChange={handleChange}
                menuIsOpen={isMenuOpen}
                value={mValue}
                isDisabled={disabled}
                formatOptionLabel={(option, {context}) => {
                    if (phoneType)
                        return context === 'menu' ? option.label : option.value;
                    return option.label;
                }}
            />
            <div
                className={"onboard-select-label " + (mValue != null ? 'onboard-select-osl-animate' : '' + " " + (mError !== undefined ? 'onboard-select-label-error' : ''))}>
                {placeholder}
            </div>
            {DropdownIndicator()}
            {mError && (<div className="onboard-select-error-hint">{mError}</div>)}
        </div>
    )
};

export default OnboardSelect;



